//TODO подумать над логикой и переписать setOuterContainerRef
//проблема что уходит в цикличность из зи width

import { useState, useRef, useEffect, useMemo } from "react";
import { Button, ButtonProps, Flex, Tooltip, Typography } from "antd";
import { TooltipPlacement } from "antd/es/tooltip";
import { CheckOutlined } from "@ant-design/icons";
import { BaseType } from "antd/lib/typography/Base";

import { copyText, truncateText } from "utils";
import copyIcon from "images/copy.svg";

import styles from "./txButton.module.css";
import { ButtonDownloadKYT } from "components";
import { useStores } from "stores";
import { GENERATE_OBSERVER_LINK } from "utils/envConstants";

interface TxButtonProps extends ButtonProps {
  truncateStart?: number;
  isWalletAddress?: boolean;
  text: string;
  title?: string;
  href?: string;
  tooltipCopyPosition?: TooltipPlacement;
  showCopyBtn?: boolean;
  textType?: BaseType;
  infoBlock?: boolean;
  kytCheck?: {
    checkId?: string;
    visibleButton: boolean;
  };
  buttonSize?: "middle" | "large";
  isBorderedButton?: boolean;
  truncateResponse?: boolean;
  tooltipTxButton?: string | React.ReactNode;
}

export const TxButton = ({
  isWalletAddress = false,
  text,
  title,
  href,
  tooltipCopyPosition = "top",
  showCopyBtn = true,
  textType = undefined,
  infoBlock = false,
  kytCheck,
  buttonSize = "middle",
  isBorderedButton = false,
  truncateResponse = true,
  tooltipTxButton,
}: TxButtonProps) => {
  const { user } = useStores();
  const { isRiskManager, isJuniorOperator, isSeniorOperator } = user.roles;

  const [copied, setCopied] = useState(false);
  const [containerWidth, setContainerWidth] = useState(400);
  const resizeObserverRef = useRef<ResizeObserver | null>(null);
  const otherElementsWidth = showCopyBtn ? 48 : 8;

  const calculateAndSetWidth = (element: HTMLElement) => {
    const width = element.offsetWidth;
    const availableWidth = width - otherElementsWidth;
    // setContainerWidth(Math.max(availableWidth, 150));

    setContainerWidth(250);
  };

  const setOuterContainerRef = (node: HTMLDivElement | null) => {
    if (resizeObserverRef.current) {
      resizeObserverRef.current.disconnect();
      resizeObserverRef.current = null;
    }

    if (node) {
      const parentContainer = node.closest('[class*="infoCol"]') || node.parentElement;
      const targetElement = parentContainer ? (parentContainer as HTMLElement) : node;

      calculateAndSetWidth(targetElement);

      const resizeObserver = new ResizeObserver(() => {
        calculateAndSetWidth(targetElement);
      });

      resizeObserver.observe(targetElement);
      resizeObserverRef.current = resizeObserver;
    }
  };

  useEffect(() => {
    return () => {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
      }
    };
  }, []);

  const getTruncationParams = (width: number) => {
    if (truncateResponse) {
      if (width < 190) {
        return { start: isWalletAddress ? 8 : 7, end: isWalletAddress ? 7 : 0 };
      } else if (width < 190) {
        return { start: isWalletAddress ? 4 : 5, end: isWalletAddress ? 3 : 0 };
      } else if (width < 200) {
        return { start: isWalletAddress ? 5 : 7, end: isWalletAddress ? 4 : 0 };
      } else if (width < 230) {
        return { start: isWalletAddress ? 6 : 8, end: isWalletAddress ? 5 : 0 };
      } else if (width < 300) {
        return { start: isWalletAddress ? 8 : 10, end: isWalletAddress ? 7 : 0 };
      } else {
        return { start: isWalletAddress ? 10 : 12, end: isWalletAddress ? 9 : 0 };
      }
    }

    return { start: isWalletAddress ? 8 : 10, end: isWalletAddress ? 7 : 0 };
  };

  const { start: truncateStart, end: truncateEnd } = getTruncationParams(containerWidth);

  const truncatedText = useMemo(() => {
    if (!text) return "";
    return truncateText(text, truncateStart, truncateEnd);
  }, [text, truncateStart, truncateEnd]);

  if (!text) {
    return "";
  }

  const handleCopyText = (text: string) => {
    copyText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1000);
    });
  };

  const showButtonKYT =
    (isSeniorOperator || isJuniorOperator || isRiskManager) && kytCheck && kytCheck.visibleButton && kytCheck.checkId;

  const imgSize = () => {
    if (isBorderedButton) {
      return "icon-lg";
    }
    return buttonSize === "large" ? "icon-2xl" : "icon-xl";
  };

  const CopyBtn = () => {
    return (
      <Tooltip
        trigger="hover"
        placement={tooltipCopyPosition}
        title={
          <span>
            {copied ? "Скопировано" : isWalletAddress ? "Скопировать адрес кошелька" : "Скопировать хеш транзакции"}
          </span>
        }
      >
        <Button
          type={isBorderedButton ? "text" : "link"}
          className={isBorderedButton ? "grey-border square icon-3xl" : styles.copyButton}
          size={buttonSize}
          onClick={() => handleCopyText(text)}
        >
          {copied ? <CheckOutlined /> : <img src={copyIcon} className={`copyIcon ${imgSize()}`} alt="" />}
        </Button>
      </Tooltip>
    );
  };

  return (
    <Tooltip title={!!tooltipTxButton ? tooltipTxButton : undefined}>
      <Flex
        ref={setOuterContainerRef}
        gap={4}
        justify={isBorderedButton ? "space-between" : "flex-start"}
        className={isBorderedButton ? "full-width" : ""}
        onClick={(e: React.MouseEvent<HTMLDivElement>) => {
          e.stopPropagation();
        }}
      >
        <Flex vertical gap="2px" align={"flex-start"}>
          {title && <Typography.Text className={`${styles.TxTitle}`}>{title}</Typography.Text>}
          {GENERATE_OBSERVER_LINK ? (
            <Button type="link" size="middle" href={href} target="_blank" className={styles.txButton}>
              <Typography.Text
                key={`${truncateStart}-${truncateEnd}-${containerWidth}-${Date.now()}`}
                type={textType}
                className={`${styles.TxText} ${infoBlock ? "text-middle" : ""} text-underline`}
              >
                {truncatedText}
              </Typography.Text>
            </Button>
          ) : (
            <div className={`${styles.txButton} ${styles.noLinkClass}`}>
              <Typography.Text
                key={`${truncateStart}-${truncateEnd}-${containerWidth}-${Date.now()}`}
                type={textType}
                className={`${styles.TxText} ${infoBlock ? "text-middle" : ""}`}
              >
                {truncatedText}
              </Typography.Text>
            </div>
          )}
        </Flex>
        <Flex>
          {showCopyBtn && <CopyBtn />}
          {showButtonKYT && <ButtonDownloadKYT checkId={kytCheck.checkId!} tooltip="Скачать отчет AML проверки" />}
        </Flex>
      </Flex>
    </Tooltip>
  );
};
